import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { CotizacionesComponent } from './cotizaciones/cotizaciones.component';
import { CotizacionesRoutingModule } from './cotizaciones-routing.module';
import { PipesModule } from 'app/pipes/pipes.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { ScheduleDialogComponent } from './schedule-dialog/schedule-dialog.component';



@NgModule({
  declarations: [CotizacionesComponent,ScheduleDialogComponent],
  imports: [
    SharedModule,
    CotizacionesRoutingModule,
    PipesModule,
    MatTableModule, 
    MatSortModule
  ],
})
export class CotizacionesModule { }
